// ======================================================================
// File Name       : AuthorityDetailForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';
import { HYPHEN } from '../../constants';

class AuthorityDetail extends React.Component {
  /**
     * Get authority text by number
     * @param {number} authority
     * @return {string}
     */
  getAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '参照のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  /**
     * Get scoring authority text by number
     * @param {number} authority
     * @return {string}
     */
  getScoringAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '採点のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  getAuthorityDisplayText(authority) {
    switch (authority) {
      case 0:
        return '非表示';
      case 1:
      case 2:
        return '表示';
      default:
        return '';
    }
  }

  getMaterialAuthorityText(authority) {
    switch (authority) {
      case 1:
        return 'ダウンロード可';
      default:
        return HYPHEN;
    }
  }

  /**
     * Life cycle function
     */
  shouldComponentUpdate(nextProps) {
    return nextProps.authority !== null;
  }

  /**
     * Render method of component
     */
  render() {
    const { managementAuthorityName, managementFunctionAuthorityInfo, managementFunctionAuthorityDisplayInfo } = this.props.authority;
    return (
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Form.Group>
            <Col sm={3} className="padding-top-bottom-10 margin-left-10">ロール名</Col>
            <Col sm={8} className="padding-top-bottom-10 padding-left-75">{managementAuthorityName}</Col>
          </Form.Group>
          <Form.Group>
            <Col sm={12} className="margin-left-10"><p>画面表示</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ユーザー管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ユーザーグループ設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">コース</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ビデオ/ドキュメント/リンク/ドリル</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">学習履歴</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">添削管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">メッセージ管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">お知らせ</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">メール連絡</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ライブ</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">受講ユーザー画面設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">システム利用実績管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ロール設定</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">TOP画面ダウンロードボタン</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form.Group>
          <Form.Group>
            <Col sm={12} className="margin-left-10"><p>権限設定</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ユーザー管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.userManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ユーザーグループ設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.groupManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">コース</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.courseManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ビデオ/ドキュメント/リンク/ドリル</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.contentManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">学習履歴</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.achievementManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">添削管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getScoringAuthorityText(
                          managementFunctionAuthorityInfo.scoringManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">メッセージ管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getScoringAuthorityText(
                          managementFunctionAuthorityInfo.messageManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">お知らせ</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.noticeManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">メール連絡</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.emailManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ライブ</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.liveManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">受講ユーザー画面設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.userfrontManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">システム利用実績管理</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.performanceManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">ロール設定</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.authorityManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={3} className="lable-content padding-top-bottom-10 margin-left-10">TOP画面ダウンロードボタン</Col>
                  <Col sm={7} className="lable-value padding-top-bottom-10">
                    {
                      managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getMaterialAuthorityText(
                          managementFunctionAuthorityInfo.materialManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default AuthorityDetail;
